module.exports = __webpack_public_path__ + "static/exterior-3-449c2a2f7cf5b5ffbba2a86cf52bb5f8.jpg";